import { useState } from "react";

import { Collapse } from "@mui/material";

import { useAlertBannerRef } from "../layout/useAlertBanner";

import { AlertRenderer, ExpandChevron } from "./components";
import { useAlertSystem } from "./useAlertSystem";

export const AlertBanner = () => {
  const bannerRef = useAlertBannerRef();
  const { alerts, orgQuery, alertData, systemAlert } = useAlertSystem();
  const [expanded, setExpanded] = useState(false);

  const hasMultipleAlerts = alerts.length > 1;
  const firstAlert = alerts[0];
  const additionalAlerts = alerts.slice(1);

  const expandChevron = hasMultipleAlerts ? (
    <ExpandChevron
      count={additionalAlerts.length}
      expanded={expanded}
      onToggle={() => setExpanded((prev) => !prev)}
    />
  ) : undefined;

  return (
    <div ref={bannerRef}>
      {firstAlert ? (
        <AlertRenderer
          alertType={firstAlert}
          orgId={orgQuery.data?.org?.id}
          shopId={orgQuery.data?.org?.shopId ?? undefined}
          scriptStatusExpected={alertData.scriptStatusExpected}
          scriptStatusFound={alertData.scriptStatusFound}
          systemAlert={systemAlert}
          endContent={expandChevron}
        />
      ) : null}
      {additionalAlerts.length > 0 ? (
        <Collapse in={expanded}>
          {additionalAlerts.map((alertType) => (
            <AlertRenderer
              key={alertType}
              alertType={alertType}
              orgId={orgQuery.data?.org?.id}
              shopId={orgQuery.data?.org?.shopId ?? undefined}
              scriptStatusExpected={alertData.scriptStatusExpected}
              scriptStatusFound={alertData.scriptStatusFound}
              systemAlert={systemAlert}
              additionalAlert
            />
          ))}
        </Collapse>
      ) : null}
    </div>
  );
};

// Re-export CustomEventsEsmAlert for use in ConfigureCustomMetrics.tsx
export { CustomEventsEsmAlert } from "./components";
